export default function Canvas_Linear_Gradient() {
  return (
    <div>
      <h1>Canvas_Linear_Gradient Component</h1>
    </div>
  );
}
